var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"title":"חשבוניות שלא נשלחו","linkTo":"/invoices?notSentByEmail=true","actionButton":"לכל החשבוניות שלא נשלחו","number":_vm.number,"loading":_vm.loading,"error":_vm.error}})}
var staticRenderFns = []

export { render, staticRenderFns }